import React from 'react';
import { useLoaderData } from 'react-router-dom';
import QuizOptions from '../quizoptions/QuizOptions';

const QuizeDetails = () => {
    const Quizs = useLoaderData();
    const {questions,name}= Quizs.data;

    return (
        <div className='justify-center bg-gray-300'>
            <p className='text-center text-xl p-5'>Quiz of {name}</p>
            {questions.map((options , index) => <QuizOptions key={index}  options={options}></QuizOptions>)}
            
        </div>
    );
};

export default QuizeDetails;

